import { NgModule, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  // Resolve,
  ResolveFn,
  RouterModule,
  RouterStateSnapshot,
  Routes,
} from '@angular/router';
// import { LayoutModule } from './layout/layout.module';
// import { LayoutComponent } from './layout/layout.component';
import { AfterLoginComponent } from './after-login/after-login.component';
import { setLayout } from './layout/layout.resolver';
import { LayoutService, PageLayout } from './layout/layout.service';
// import { AuthorizedLayoutComponent } from './layout/authorized-layout/authorized-layout.component';
// import { Observable } from 'rxjs';
import { AuthGuard } from '@app/_guards/auth.guard';
import { OnboardingGuard } from '@app/_guards/onboarding.guard';
// import { LoginComponent } from './auth/login/login.component';
// import { GenericComponent as AuthGenericComponent } from './auth/generic/generic.component';
// import { LogoutComponent } from './auth/logout/logout.component';

// export const heroResolver: ResolveFn<Hero> = (  route: ActivatedRouteSnapshot,  state: RouterStateSnapshot,) => {
//   return inject(HeroService).getHero(route.paramMap.get('id')!);
// };

// @Injectable({ providedIn: 'root' })
// export class HeroResolver implements Resolve<number | undefined> {
//   constructor(private service: LayoutService) {}
//   resolve(
//     route: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot
//   ): Observable<number| undefined>|Promise<number| undefined>|number| undefined {
//     return this.service.getHero(route.paramMap.get('id'));
//   }
// }

export const companyIdResolver: ResolveFn<string | number | undefined> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const layoutService = inject(LayoutService);
  let companyId = route.paramMap.get('companyId')!;
  // .getHero(
  // );
  layoutService.setCompanyId(companyId);
  return companyId;
};

const routes: Routes = [
  // { path: 'home', component: LayoutComponent },

  {
    path: 't/:uuid',
    loadChildren: () =>
      import('./submitter-ticket/submitter-ticket.module').then((m) => m.SubmitterTicketModule),
  },

  // ---------------------------------------------------

  {
    path: ':companyId/:projectId/tasks',
    // component: AuthorizedLayoutComponent,
    loadChildren: () =>
      import('./tasks/tasks.module').then((m) => m.TasksModule),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
      companyId: companyIdResolver,
    },

    // canDeactivate: [VersionGuard],
    // canActivate: [AuthGuard, AdminGuard],
    // canActivateChild: [AuthGuard, AdminGuard],
    // canLoad: [AuthGuard, AdminGuard],
    canMatch: [AuthGuard],
  },
  {
    path: ':companyId/:projectId/sprints',
    loadChildren: () =>
      import('./sprints/sprints.routes').then((m) => m.SPRINTS_ROUTES),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
      companyId: companyIdResolver,
    },
    canMatch: [AuthGuard],
  },
  {
    path: ':companyId/:projectId/backlog',
    loadChildren: () =>
      import('./backlog/backlog.routes').then((m) => m.BACKLOG_ROUTES),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
      companyId: companyIdResolver,
    },
    canMatch: [AuthGuard],
  },
  {
    path: ':companyId/:projectId/board',
    loadChildren: () =>
      import('./project-board/project-board.routes').then((m) => m.PROJECT_BOARD_ROUTES),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
      companyId: companyIdResolver,
    },
    canMatch: [AuthGuard],
  },
  {
    path: ':companyId/:projectId/attachments',
    loadChildren: () =>
      import('./project-attachments/project-attachments.routes').then(
        (m) => m.PROJECT_ATTACHMENTS_ROUTES,
      ),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
      companyId: companyIdResolver,
    },
    canMatch: [AuthGuard],
  },
  {
    path: ':companyId/:projectId/notes',
    loadChildren: () =>
      import('./project-notes/project-notes.routes').then(
        (m) => m.PROJECT_NOTES_ROUTES,
      ),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
      companyId: companyIdResolver,
    },
    canMatch: [AuthGuard],
  },
  {
    path: ':companyId/:projectId/dashboard',
    loadChildren: () =>
      import('./project-dashboard/project-dashboard.routes').then((m) => m.PROJECT_DASHBOARD_ROUTES),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
      companyId: companyIdResolver,
    },
    canMatch: [AuthGuard],
  },
  {
    path: ':companyId/:projectId/matrix',
    loadChildren: () =>
      import('./project-matrix/project-matrix.routes').then((m) => m.PROJECT_MATRIX_ROUTES),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
      companyId: companyIdResolver,
    },
    canMatch: [AuthGuard],
  },
  {
    path: ':companyId/:projectId/scoring',
    loadChildren: () =>
      import('./project-scoring/project-scoring.routes').then((m) => m.PROJECT_SCORING_ROUTES),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
      companyId: companyIdResolver,
    },
    canMatch: [AuthGuard],
  },
  {
    path: ':companyId/projects',
    loadChildren: () =>
      import('./projects/projects.module').then((m) => m.ProjectsModule),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
      companyId: companyIdResolver,
    },
    canMatch: [AuthGuard],
  },
  {
    path: ':companyId/version',
    loadChildren: () =>
      import('./i3version/i3version.module').then((m) => m.I3versionModule),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
      companyId: companyIdResolver,
    },
    canMatch: [AuthGuard],
  },
  {
    path: 'companies',
    loadChildren: () =>
      import('./company/company.module').then((m) => m.CompanyModule),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
      companyId: companyIdResolver,
    },
    canMatch: [AuthGuard],
  },
  {
    path: 'company',
    loadChildren: () =>
      import('./company-team/company-team.module').then(
        (m) => m.CompanyTeamModule
      ),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
      companyId: companyIdResolver,
    },
    canMatch: [AuthGuard],
  },
  {
    path: ':companyId/daily-resume',
    loadChildren: () =>
      import('./daily-resume/daily-resume.module').then(
        (m) => m.DailyResumeModule
      ),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
      companyId: companyIdResolver,
    },
    canMatch: [AuthGuard],
  },
  {
    path: ':companyId/notes',
    loadComponent: () =>
      import('./notes-page/notes-page.component').then((m) => m.NotesPageComponent),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
      companyId: companyIdResolver,
    },
    canMatch: [AuthGuard],
  },
  {
    path: ':companyId/users',
    loadChildren: () =>
      import('./company-users/company-users.module').then(
        (m) => m.CompanyUsersModule
      ),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
      companyId: companyIdResolver,
    },
    canMatch: [AuthGuard],
  },
  // ---------------------------------------------------

  {
    path: 'personal-plan',
    loadChildren: () =>
      import('./personal-plan/personal-plan.module').then(
        (m) => m.PersonalPlanModule
      ),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
      companyId: companyIdResolver,
    },
    canMatch: [AuthGuard],
  },

  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
    // component: AuthGenericComponent,
    // children: [
    //   {
    //     path: 'login', // child route path
    //     // title: resolvedChildATitle,
    //     component: LoginComponent, // child route component that the router renders
    //   },
    //   {
    //     path: 'logout',
    //     // title: 'child b',
    //     component: LogoutComponent, // another child route component that the router renders
    //   },
    // ],
  },

  // // {
  // //   path: ':companyId/:projectId/tasks',
  // //   loadChildren: () =>
  // //     import('./tasks/tasks.module').then((m) => m.TasksModule),
  // //   // component: AuthGenericComponent,
  // //   // children: [
  // //   //   {
  // //   //     path: 'login', // child route path
  // //   //     // title: resolvedChildATitle,
  // //   //     component: LoginComponent, // child route component that the router renders
  // //   //   },
  // //   //   {
  // //   //     path: 'logout',
  // //   //     // title: 'child b',
  // //   //     component: LogoutComponent, // another child route component that the router renders
  // //   //   },
  // //   // ],
  // // },
  // {
  //   path: ':companyId/projects',
  //   loadChildren: () =>
  //     import('./projects/projects.module').then((m) => m.ProjectsModule),
  //   // component: AuthGenericComponent,
  //   // children: [
  //   //   {
  //   //     path: 'login', // child route path
  //   //     // title: resolvedChildATitle,
  //   //     component: LoginComponent, // child route component that the router renders
  //   //   },
  //   //   {
  //   //     path: 'logout',
  //   //     // title: 'child b',
  //   //     component: LogoutComponent, // another child route component that the router renders
  //   //   },
  //   // ],
  // },
  // {
  //   path: 'companies',
  //   loadChildren: () =>
  //     import('./company/company.module').then(
  //       (m) => m.CompanyModule
  //     ),
  // },
  // {
  //   path: ':companyId/daily-resume',
  //   loadChildren: () =>
  //     import('./daily-resume/daily-resume.module').then(
  //       (m) => m.DailyResumeModule
  //     ),
  // },
  // {
  //   path: ':companyId/users',
  //   loadChildren: () =>
  //     import('./company-users/company-users.module').then(
  //       (m) => m.CompanyUsersModule
  //     ),
  // },
  // {
  //   path: ':companyId/teams',
  //   loadChildren: () =>
  //     import('./company-team/company-team.module').then(
  //       (m) => m.CompanyTeamModule
  //     ),
  //   // component: AuthGenericComponent,
  //   // children: [
  //   //   {
  //   //     path: 'login', // child route path
  //   //     // title: resolvedChildATitle,
  //   //     component: LoginComponent, // child route component that the router renders
  //   //   },
  //   //   {
  //   //     path: 'logout',
  //   //     // title: 'child b',
  //   //     component: LogoutComponent, // another child route component that the router renders
  //   //   },
  //   // ],
  // },
  {
    path: ':companyId/ticket-widgets',
    loadChildren: () =>
      import('./ticket-widgets/ticket-widgets.module').then((m) => m.TicketWidgetsModule),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
      companyId: companyIdResolver,
    },
    canMatch: [AuthGuard],
  },
  {
    path: 'notifications',
    loadChildren: () =>
      import('./notification/notification.module').then((m) => m.NotificationModule),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
    },
    canMatch: [AuthGuard],
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./profile/profile.module').then((m) => m.ProfileModule),
    resolve: {
      layout: setLayout(PageLayout.Authorized),
    },
    canMatch: [AuthGuard],
  },
  {
    path: 'after-login',
    component: AfterLoginComponent,
    canMatch: [AuthGuard],
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./onboarding/onboarding.module').then(m => m.OnboardingModule),
    canMatch: [AuthGuard, OnboardingGuard],
  },
  {
    // Stripe Checkout redirect targets (STRIPE_CHECKOUT_SUCCESS_URL / _CANCEL_URL).
    path: 'billing/success',
    loadComponent: () =>
      import('./profile/billing/billing-result.component').then((m) => m.BillingResultComponent),
    data: { result: 'success' },
    resolve: {
      layout: setLayout(PageLayout.Authorized),
    },
    canMatch: [AuthGuard],
  },
  {
    path: 'billing/cancel',
    loadComponent: () =>
      import('./profile/billing/billing-result.component').then((m) => m.BillingResultComponent),
    data: { result: 'cancel' },
    resolve: {
      layout: setLayout(PageLayout.Authorized),
    },
    canMatch: [AuthGuard],
  },
  { path: '**', redirectTo: '/after-login' },
  { path: '', redirectTo: '/after-login', pathMatch: 'full' },
  // { path: '', redirectTo: '/dashboard', pathMatch: 'full', outlet: "main"},
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes
      // { enableTracing: true }
    ),
    // LayoutModule
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
